import jsonToCsvExport from 'json-to-csv-export';

export type FlatExportableStore = {
  id: string;
  name: string;
  type: string;
  productsCount?: number;
  baseCurrency: string;
  presentmentCurrencies?: string[];
  chargeCurrencies?: string[];
  createdAt?: Date | string;
};

export type StoreExportEntry = {
  storeId: string;
  storeName: string;
  template: unknown;
};

export type StoreExportBundle = {
  exportedAt: string;
  count: number;
  stores: StoreExportEntry[];
};

export type StoreExportFormat = 'template' | 'summary';

export const buildStoreExportBundle = (entries: StoreExportEntry[]): StoreExportBundle => ({
  exportedAt: new Date().toISOString(),
  count: entries.length,
  stores: entries,
});

const buildExportFilename = (prefix: string, exportedAt: string, extension: string) =>
  `${prefix}-${exportedAt.split('T')[0]}.${extension}`;

export const downloadStoreExportBundle = (bundle: StoreExportBundle) => {
  const blob = new Blob([JSON.stringify(bundle, null, 2)], { type: 'application/json' });
  const url = window.URL.createObjectURL(blob);
  const anchor = document.createElement('a');
  anchor.href = url;
  anchor.download = buildExportFilename('stores-export-360', bundle.exportedAt, 'json');
  document.body.appendChild(anchor);
  anchor.click();
  window.URL.revokeObjectURL(url);
  document.body.removeChild(anchor);
};

export const buildFlatStoreExportRows = (stores: FlatExportableStore[]) =>
  stores.map((store) => ({
    id: store.id,
    name: store.name,
    type: store.type,
    productsCount: store.productsCount ?? 0,
    baseCurrency: store.baseCurrency,
    presentmentCurrencies: store.presentmentCurrencies?.join('; ') ?? '',
    chargeCurrencies: store.chargeCurrencies?.join('; ') ?? '',
    createdAt: store.createdAt ? new Date(store.createdAt).toISOString() : '',
  }));

export const downloadFlatStoresCsv = (stores: FlatExportableStore[]) => {
  const exportedAt = new Date().toISOString();
  jsonToCsvExport({
    data: buildFlatStoreExportRows(stores),
    filename: buildExportFilename('stores-export', exportedAt, 'csv'),
  });
};
